import { render } from "./InstructorOjtOrgDataTable.vue?vue&type=template&id=63061bc5&scoped=true"
import script from "./InstructorOjtOrgDataTable.vue?vue&type=script&lang=js"
export * from "./InstructorOjtOrgDataTable.vue?vue&type=script&lang=js"

import "./InstructorOjtOrgDataTable.vue?vue&type=style&index=0&id=63061bc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63061bc5"]])

export default __exports__